export default {
  data() {
    return {
      model: {
        name: '',
        sortColumn: 'name',
        searchColumns: ['name'] // [ column, [ model, column ] ]
      },
      options: {},
      pagedItems: [],
      totalItems: 0,
      loading: false,
      search: '',
      searchTo: null,
      showArchived: false
    }
  },
  computed: {
    headers () {
      const headers = [...this.defaultHeaders]
      if (this.showArchived) {
        headers.push({ text: '', sortable: false })
      }
      return headers
    }
  },
  methods: {
    async updateIndex () {
      try {
        this.loading = true
        const { items, total } = await this.fetchItems()
        this.pagedItems = items
        this.totalItems = total
      } catch (error) {
        console.error('[lazyItems]', error)
      } finally {
        this.loading = false
      }
    },
    async fetchItems () {
      try {
        const { name: model, sortColumn, searchColumns } = this.model
        const { sortBy, sortDesc, page, itemsPerPage } = this.options

        const params = {
          limit: itemsPerPage,
          offset: page * itemsPerPage - itemsPerPage
        }

        if (sortBy.length) {
          params.sort = `${model}.${sortBy[0]}+${sortDesc[0] ? 'DESC' : 'ASC'}`
        } else if (sortColumn) {
          params.sort = `${model}.${sortColumn}+ASC`
        }

        if (this.search) {
          params.search = [...searchColumns].map(column => {
            if (Array.isArray(column)) {
              let [model, prop] = column
              return `${model}.${prop}+${this.search}`
            }
            return `${model}.${column}+${this.search}`
          }).join()
          params.searchMode = 'OR'
        }

        if (this.showArchived) {
          params.archive = true
        }

        const { items, total } = await this.$store.dispatch('lazyItems/getItems', { model, params })

        return Promise.resolve({
          items,
          total
        })
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async restoreItem (item) {
      try {
        await this.$store.dispatch('undoDestroyItem', {
          model: this.model.name,
          item
        })
        this.updateIndex()
      } catch (error) {
        console.error('[lazyItems]', error)
      }
    },
    showItemDetail (item) {
      const { name } = this.model

      if (item.archivedAt) return // won't show
      if (name === 'users' && !this.$can(item.role)) return

      this.$router.push({ name: `${name}/id`, params: { id: item.id } })
    }
  },
  watch: {
    options: {
      handler () {
        this.updateIndex()
      },
      deep: true
    },
    showArchived () {
      this.updateIndex()
    },
    search (value) {
      // debounce
      clearTimeout(this.searchTo)
      this.searchTo = setTimeout(this.updateIndex, value ? 500 : 0)
    }
  }
}